import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import * as styles from "./style.module.scss";
import UISwitch from "@/components/ui-controls/ui-switch";

const Header = ({ selected, onChange }) => {
  return (
    <ListItem
      key={"main-title"}
      style={{ paddingBottom: 0 }}
      alignItems="flex-start"
    >
      <ListItemText
        primary={<HeaderPrimary selected={selected} onChange={onChange} />}
        // secondary={<HeaderButtons selected={selected} onChange={onChange} />}
      />
    </ListItem>
  );
};
export default Header;

const HeaderPrimary = ({ selected, onChange }) => {
  return (
    <Typography component="span" className={styles?.headerPrimary}>
      <Typography
        className={styles?.menuHeading}
        sx={{ display: "inline" }}
        variant="h3"
        fontWeight={500}
        color="custom.heading"
      >
        Notifications
      </Typography>
      <UISwitch
        name="unread"
        checked={selected === "unread"}
        size="sm"
        label="Only see unread"
        handleChange={onChange}
        defaultStyled={false}
      />
    </Typography>
  );
};

const HeaderButtons = ({ selected, onChange }) => {
  return (
    <Typography component={"span"} className={styles?.btnContainer}>
      {HeaderBtnOptions.filter((item) => item.name !== "unread").map((opt) => (
        <Button
          key={opt?.id}
          name={opt?.name}
          className={`${styles.headerBtn} ${
            opt.name === selected && styles.btnSelected
          }`}
          onClick={onChange}
        >
          {opt?.title}
        </Button>
      ))}
    </Typography>
  );
};

const HeaderBtnOptions = [
  { id: 1, title: "Direct", name: "direct" },
  { id: 2, title: "Unread", name: "unread" },
  { id: 3, title: "Following", name: "following" },
];
